<template>
  <div id="app" :style="{ opacity: client_id ? 1 : 0 }">
    <div class="view-container" :style="{ backgroundColor: backgroundColor, color: fontColor }">
        <Page v-for="(page,i) in pages" :client="client" :page="page" :key="i" />
        <!-- 
        <Home @showTerms="showTerms" />
        <CHAccount v-if="pages.indexOf('ch-account') > -1" @showTerms="showTerms"/>
        <CHMembership v-if="pages.indexOf('ch-membership') > -1" />
        <CHLoyalty v-if="pages.indexOf('ch-loyalty') > -1" />
        <Cats v-if="pages.indexOf('cats') > -1" />  
        <Comps v-if="pages.indexOf('comps') > -1" @showSurveyTerms="showSurveyTerms" />
        <Survey v-if="pages.indexOf('survey') > - 1" @popPage="popPage" @showSurveyTerms="showSurveyTerms" />  
        <About v-if="pages.indexOf('about') > -1" @popPage="popPage"/>
        <Join v-if="pages.indexOf('join') > -1" :join="join" @popPage="popPage" @showTerms="showTerms" />
        <Copper v-if="pages.indexOf('copper') > -1" @popPage="popPage" @showTerms="showTerms" @showDetail="pushPage('copper-detail')" /> 
        <CopperDetail v-if="pages.indexOf('copper-detail') > -1" @popPage="popPage" />  
        <CopperWelcome v-if="pages.indexOf('copper-welcome') > -1" @popPage="popPage" />   
        <Welcome v-if="pages.indexOf('welcome') > -1" @popPage="popPage" />  
              <Business v-if="pages.indexOf('business') > -1" :business="business" @popPage="popPage" @showTerms="showTerms"/>
        <Contact v-if="pages.indexOf('contact') > -1" @popPage="popPage"/>
              <Approve v-if="pages.indexOf('approve') > -1" :approve="approve" @popPage="popPage" @payRequest="payRequest"/>
        <Offers v-if="pages.indexOf('offers') > -1" @popPage="popPage" />  
        <Pay v-if="pages.indexOf('pay') > -1" @popPage="popPage" :pay="pay" @payComplete="payComplete" @goneCopper="goneCopper" />
        
              <FeedBack v-if="pages.indexOf('feedback') > -1" :approve="approve" @popPage="popPage" />
        <UnSub v-if="pages.indexOf('unsub') > -1" :user="user" @unsub="unsub"/>
              <Redeem v-if="auth && pages.indexOf('redeem') > -1" :coupon="coupon" />
        <Account v-if="pages.indexOf('account') > -1" />   
        <Auth v-if="pages.indexOf('auth') > -1 && pages.indexOf('account') == -1" />
        <Reset v-if="pages.indexOf('reset') > -1" @success="pages.push('auth')" />
        <Verify v-if="pages.indexOf('verify') > -1" @success="pages.push('auth')" /> 
        <Book v-if="pages.indexOf('book-now') > -1" />
        <Contact v-if="pages.indexOf('contact-us') > -1" />  
        <Terms v-if="pages.indexOf('terms') > -1" /> 
        <FAQ v-if="pages.indexOf('faq') > -1" />
        <Privacy v-if="pages.indexOf('privacy') > -1" />   
        <Loyalty v-if="pages.indexOf('loyalty') > -1" />
        <Refer v-if="pages.indexOf('refer') > -1" />
        <NoSite v-if="pages.indexOf('no-site') > -1" />  
        <takeSurvey v-if="pages.indexOf('take-survey') > -1" />
        <Scores v-if="pages.indexOf('scores') > -1" />
        <EditAvatar v-if="pages.indexOf('edit-avatar') > -1" />
        <EditPicture v-if="pages.indexOf('edit-picture') > -1" />

        -->
    </div>
  </div>
</template>

<script>
/*
import Book from '@/components/Book.vue'
import Home from '@/components/Home.vue'
import VHeader from '@/components/VHeader.vue'
import Contact from '@/components/Contact.vue'
import About from '@/components/About.vue'
import Join from '@/components/Join.vue'
//import Business from '@/components/Business.vue'
import Terms from '@/components/Terms.vue'
import Pay from '@/components/Pay.vue'
//import Approve from '@/components/Approve.vue'
import Offers from '@/components/Offers.vue'
import Comps from '@/components/Comps.vue'
import Cats from '@/components/Cats.vue'
import Survey from '@/components/Survey.vue'
//import FeedBack from '@/components/FeedBack.vue'
import UnSub from '@/components/UnSub.vue'
import Auth from '@/components/Auth.vue'
//import Redeem from '@/components/Redeem.vue'
import Reset from '@/components/Reset.vue'
import Verify from '@/components/Verify.vue'
import Welcome from '@/components/Welcome.vue';
import Copper from '@/components/Copper.vue';
import CopperDetail from '@/components/CopperDetail.vue';
import CopperWelcome from '@/components/CopperWelcome.vue';

import Alert from '@/utils/Alert.js';
import Account from '@/components/Account.vue'
import CHAccount from '@/components/CHAccount.vue'
import CHMembership from '@/components/CHMembership.vue'
import CHLoyalty from '@/components/CHLoyalty.vue'
import FAQ from '@/components/FAQ.vue'
import Privacy from '@/components/Privacy.vue'
import Loyalty from '@/components/Loyalty.vue'
import Refer from '@/components/Refer.vue'
import NoSite from '@/components/NoSite.vue';
import takeSurvey from '@/components/takeSurvey.vue';
import Scores from '@/components/Scores.vue'
import EditAvatar from '@/components/editAvatar.vue';
import EditPicture from '@/components/editPicture.vue';
*/
import { mapActions, mapMutations, mapState } from 'vuex';

import WebSoc from '@/utils/WebSoc.js'


import Page from '../src/components/Page';

export default {
  name: 'app',
  computed: {
    ...mapState(['client','pages','TsCs','terms','user','_id','auth','backgroundColor','fontColor','client_id','id','testURL'])
  },
  components: {
    /*
    VHeader,
    Home,
    Contact,
    About,
    Join,
    Privacy,
    //Business,
    Terms,
    Pay,
    //Approve,
    Offers,
    Comps,
    Cats,
    Survey,
    //FeedBack,
    UnSub,
    Auth,
    //Redeem,
    Reset,
    Verify,
    Welcome,
    Copper,
    CopperDetail,
    CopperWelcome,
    Account,
    CHAccount,
    CHMembership,
    CHLoyalty,
    Book,
    FAQ,
    Loyalty,
    Refer,
    NoSite,
    takeSurvey,
    Scores,
    EditAvatar,
    EditPicture,
    */

    Page
  },
  watch: {
    auth ( auth ) { if ( auth ) { setTimeout(() => this.popPage('auth'),400); this.checkURL(this.$route) } },
    //pages: ( pages ) => console.log('pages',pages)
  },
  mounted () {
    var width = parseInt(getComputedStyle(this.$el.querySelector('.view-container')).width);
    console.log('width',width)
    width < 414 && this.setValue({ k: 'scale', v: width / 414 })
    this.initWS(this.$route);
  },
  data () {
    return {
      pay: false,
      approve: false,
      join: false,
      business: false,
      coupon: false
    }
  },
  methods: {
    goneCopper () {
      this.popPage('pay');
      this.pushPage('copper-welcome');
    },
    unsub ( unsub ) {
      if ( !unsub ) return;
      WebSoc.SEND({ t: 'unsub', data: { _id: this._id, id: this.id, user: this.user }})
      Alert.message('You have been unsubscribed')
    },
    showSurveyTerms ( terms_id ) {
      //console.log('showSurveyTerms',terms_id);
      this.setValue({ k: 'terms', v: '' })
      
      WebSoc.SEND({ t: 'getQuill', data: { _id: terms_id }},resp => {
        //console.log('getQuill',resp);
          this.setValue({ k: 'terms', v: resp.html });
          this.pushPage('terms');
          setTimeout(() => {
            this.setValue({ k: 'terms', v: '' });
          },10000);
      })
      
    },
    showTerms () {
        this.pushPage('terms');
        this.setValue({
          k: 'terms',
          v: this.TsCs
        });
        !this.TsCs && WebSoc.SEND({ t: 'getTsCs' },resp => ['terms','TsCs'].forEach(k => this.setValue({ k, v: resp })));
    },
    payRequest ( payment ) {
        this.pushPage('pay');
        this.pay = payment;
    },
    payComplete ( resp ) {
        this.pay.complete(resp);
    },
    checkURL ( route ) {
      return;
      var pages = this.pages;
      var show = (page) => setTimeout(() => this.pushPage(page),300)
      var pop = page => setTimeout(() => this.popPage(page),300);
      var query = route.fullPath.split('?')[1];
          query && this.setValue({ k: 'query', v: query });
          query && this.setValue({ k: 'Query', v: route.query });
      var url = route.path.split('/');
          url.splice(0,1);
          switch ( url[0] ) {
            case '':
            return show('home');
            case 'join-now':
            case 'join':  
              WebSoc.SEND({ t: 'joinNowLanded', data: { href: location.href }})
              return this.pushPage('copper-detail');
            case 'copperhouse':
            case 'join':
              this.pushPage('copper');
              this.pay = {
                copperhouse: true,
                amount: 10
              };
              try {
                var id = localStorage.id;
              } catch(e) {
                return;
              }
              if ( !id ) return;
              WebSoc.SEND({ t: 'land.copperhouse', data: { id: id, query: route.query }},resp => {
                console.log('land.copperhouse resp',resp);
              });
              break;
            case 'approve':
              console.log('sendApprove');
              WebSoc.SEND({ t: 'land.approve', data: { id: url[1], query: route.query }},resp => {
                this.approve = resp.ad;
                this.approve && this.pushPage('approve');
                console.log('land.approve resp',resp);
              });
              break;
            case 'join':
              WebSoc.SEND({ t: 'land.join', data: { query: route.query }},resp => {
                console.log('land.join resp',resp)
              });
              show('join');
              break;
            case 'business':
              WebSoc.SEND({ t: 'land.bussiness', data: { query: route.query }},resp => {
                console.log('land.business resp',resp)
              });
              return show('business');
              break;
            case 'offers':
              return show('offers');
            case 'redeem':
              if ( this.auth ) {
                show('redeem');
              } else {
                show('auth')
              }
              break;
            case 'reset':
              return show('reset');
            case 'verify':
              if ( url[1] ) {
                show('home');
                
                if ( window.webpackHotUpdate ) {
                  //var siteURL = 'copperhouse.club'
                  //var siteURL = location.host;
                  var siteURL =  this.testURL;
                } else {
                  var siteURL = location.host
                }

                !this.auth &&  WebSoc.SEND({ t: 'signInAuthVerify', data: { id: url[1], customerId: url[2], siteURL } },resp => {
                  //console.log('signInAuthVerify resp',resp);
                  if ( resp.error ) return Alert.message(resp.error);
                  if ( resp.auth ) this.setAuth(resp.auth);
                  console.log('resp.auth',resp.auth);
                  resp.auth && this.setPages(['home']);
                  resp.auth && Alert.message('Account Verified Successfully');
                  resp.auth && this.$router.push('/');
                });
                return console.log('send signInAuthVerify',url[1]);
              } else {
                return show('verify');
              }
              
            default: 
            var { _id, id } = this.$store.state;
             
            console.log({
              url,
              id,
              _id
            });
            
           console.log('url',url);
            if  ( url.length == 3 ) {
                 
                //return show('survey');
            }

              var { _id, id } = this.$store.state;
              if ( !_id ) return;
              console.log('id',id);
              WebSoc.SEND({ t: 'CHPath', data: { loyalty_id: _id, loyaltyId: id, path: this.$route.path  }},survey => {
                console.log('survey',survey);
              })

          }

          
    },
    ...mapMutations([
      'popPage',
      'pushPage',
      'setValue',
      'setAuth',
      'setPages'
    ]),
    ...mapActions([
      'initWS'
    ])
  }
}

</script>

<style lang="scss">

@media screen

  and (min-device-width: 315px)

  and (max-device-width: 812px)

  and (-webkit-min-device-pixel-ratio: 3)

  and (orientation: portrait) {

  /* CSS Rules Here */
  #app { 
    position: absolute;
  }

}

@media only screen

  and (min-device-width: 375px)

  and (max-device-width: 812px)

  and (-webkit-min-device-pixel-ratio: 3)

  and (orientation: landscape) {

  /* CSS Rules Here */
  #app {
    position: absolute;
  }

}
.quill-box {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      background-color: white;
      transition: transform 0.3s;
      transform: translateY(100%);
      &.show {
          transform: translateY(0px);
      }
      &.dn {
          display: none;
      }
}
.ta-c {
  text-align: center;
}
#app {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(100,100,100,0);
  transition: opacity 0.7s
}

@media ( min-width: 1000px ) {
  body { background-color: rgba(200,200,200,0.6); }
  #app {
    .view-container {
      margin-top: 20px;
    }
  }
}

.td-ulb {
  color: blue;
  text-decoration: underline;
}

* {
  margin: 0px;
  padding: 0px;
  font-family: 'Open Sans', sans-serif;
} 

.page {
  width: 100%;
  height: 100%;
  float: left;
  position: absolute;
  top: 0px;
  left: 0px;
  transition: transform 0.3s;
  transform: translateX(0px);
  &.off {
    transform: translateX(100%);
  }
}
.view-container {
  max-width: 414px;
  max-height: 812px;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}

input:focus, textarea:focus, select:focus {
  outline: none;
}
textarea {
  border-radius: 0px;
  border-width: 0px;
}
input {
  border-radius: 0px;
  border-width: 0px;
}

</style>
